import { t } from "@redotech/redo-i18n";
import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
import { settingsPagePermission } from "@redotech/redo-merchant-app-common/routing/settings-page-permission";

export const suppliesSettingsRoutes: PermissionedRouteObject[] = [
  {
    handle: {
      get breadcrumb() {
        return t("Shipping rules", {
          context: "merchant settings label for supplies shipping rules",
        });
      },
      permission: settingsPagePermission("supplies/shipping-rules"),
    },
    path: "supplies/shipping-rules",
    lazy: async () => {
      const { SuppliesShippingFlowBuilder } =
        await import("../../../../setting/redo-supplies/shipping-rules/supplies-shipping-flow-builder");
      return { Component: SuppliesShippingFlowBuilder };
    },
  },
];
